import React, {ForwardedRef, forwardRef} from 'react'

import {cn} from '@/src/shared/utils/twMerge'

const Body3 = forwardRef(
  (
    {children, className}: {children: React.ReactNode; className?: string},
    ref: ForwardedRef<HTMLParagraphElement>
  ) => {
    return (
      <p
        ref={ref}
        className={cn(
          'lg:text-xl',
          'text-lg',
          'text-gray-800',
          'font-normal',
          'leading-relaxed tracking-normal',
          className
        )}>
        {children}
      </p>
    )
  }
)

Body3.displayName = 'Body3'

export default Body3
